import { LayersConfig } from '@/components/map/layers-view-control'

export const REGIONS_LAYERS_CONFIG: LayersConfig = {
  fieldNames: {
    label: 'Nome dos talhões',
    checked: true,
    disabled: false,
  },
  perimeters: {
    label: 'Perímetros',
    checked: true,
    disabled: false,
  },
  satellite: {
    label: 'Satélite',
    checked: true,
    disabled: true,
  },
}
